export default {"src":"/_next/static/media/back-icon.667adffa.svg","height":15,"width":9};